/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.user-dashboard-widget-container[_ngcontent-%COMP%]   .help-icon[_ngcontent-%COMP%]{cursor:pointer!important}.user-dashboard-widget-container[_ngcontent-%COMP%]   .help-icon[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none}.user-dashboard-widget-container[_ngcontent-%COMP%]   .chart-container[_ngcontent-%COMP%]{padding:1rem .25rem 0}.width-120px[_ngcontent-%COMP%]{width:120px}.margin-top-10px[_ngcontent-%COMP%]{margin-top:10px}"];
export { styles as styles };
